import { createVNode as l, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MenuFilled.js";
import m from "../components/PfIcon.js";
const e = (r, t) => {
  const o = {
    ...r,
    ...t.attrs
  };
  return l(m, i(o, {
    icon: n
  }), null);
};
e.displayName = "MenuFilled";
e.inheritAttrs = !1;
export {
  e as default
};
